import React from 'react';
import styled from 'styled-components';
import { Field } from 'api/tasks';
import { CpBody01Secondary } from 'components/atoms/customer-portal/typography';
import { FieldSectionMapping } from 'components/organisms/field-sections/section-list';
// import { CpParaMedium } from '../typography/typo';
import { CpTaskDrawerField } from './fields/cp-task-drawer-field';

export interface CpTaskDrawerFieldSectionProps {
  fieldSection: FieldSectionMapping;
  onChange: (change: unknown, field: Field) => void;
}

export const Wrapper = styled.div`
  width: 100%;
`;

export const FieldSectionTitle = styled(CpBody01Secondary)`
  padding: var(--spacing-05) 0;
  border-bottom: 1px solid var(--cp-border-subtle);
`;

export const FieldsWrapper = styled.div`
  margin-top: var(--spacing-05);
  width: 100%;
`;

export const CPTaskDrawerFieldSection: React.FC<CpTaskDrawerFieldSectionProps> =
  ({ fieldSection, onChange }) => {
    return (
      <Wrapper>
        <FieldSectionTitle>{fieldSection.fieldSectionName}</FieldSectionTitle>
        {fieldSection.fieldOrder.length > 0 ? (
          <FieldsWrapper>
            {fieldSection.fieldOrder.map((field) => {
              return (
                <CpTaskDrawerField
                  field={field}
                  onChange={(change) => {
                    onChange(change, field);
                  }}
                />
              );
            })}
          </FieldsWrapper>
        ) : null}
      </Wrapper>
    );
  };
